export type TextMap = {
  [key: string]: {
    title: string;
    text: string;
  };
};

export const textMap: TextMap = {
  invalid_request: {
    title: 'Invalid request',
    text: 'This invitation link is no longer valid. It may have expired or could not be found. Please contact your administrator to receive a new invitation.',
  },
  access_denied: {
    title: 'Authentication Error',
    text: 'Something went wrong during the attempt to log you in.',
  },
  'Access expired.': {
    title: 'Link expired',
    text: 'You can request a new link via password reset form, available from the Login page',
  },
  unauthorized: {
    title: 'Account Deactivated',
    text: 'Your Dynamika user account has been deactivated',
  },
  'This URL can be used only once': {
    title: 'It appears that you\'ve already used this link',
    text: '"If you\'re trying to access your account, simply head over to our login page and sign in with your credentials. If you\'ve forgotten your password, don\'t fret! You can easily reset it by clicking on the "Forgot Password" link on the login page."',
  },
  unknown: {
    title: 'Unknown error',
    text: 'Please try to login',
  },
};

export const SUPPORT_EMAIL = 'support@ia-grp.com';

export const SUPPORT_TEXT = 'For more information, contact our support team:';
